import axios from '@/utils/request'

export default {
  // 2020-07-31
  findByType(params) {
    return axios.get('/print-templates/find-by-type', params)
  },
  // 2020-07-31
  update(id, params) {
    return axios.put('/print-templates/' + id, params)
  },
  //2020-07-31
  create(params) {
    return axios.post('/print-templates', params)
  },
  //2020-07-31
  delete(id) {
    return axios.delete('/print-templates/' + id)
  },
  //2020-07-31
  findById(id) {
    return axios.get('/print-templates/' + id)
  }

}

